import { Box, Container } from "@mui/material";
import { Outlet, useMatch } from "react-router";
import Header from "@/components/Header/Header";

export default function RootLayout() {
  const isDocumentReview = useMatch("/title/:titleId/round/:roundId/document/:documentId/review");
  const isDocumentComparison = useMatch(
    "/title1/:titleId1/round1/:roundId1/document1/:documentId1/title2/:titleId2/round2/:roundId2/document2/:documentId2/comparison",
  );

  return (
    <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
      {!isDocumentReview && !isDocumentComparison && (
        <Box sx={{ position: "sticky", top: 0, zIndex: 1000, padding: "16px 32px" }}>
          <Header />
        </Box>
      )}
      <Container
        component="main"
        maxWidth={false}
        sx={{ flex: 1, margin: 0, padding: "8px 32px 24px 32px" }}
      >
        <Outlet />
      </Container>
    </Box>
  );
}
